module.exports = __webpack_public_path__ + "img/ABC-COVER.97741352.png";